import GIF from "../assets/loading.gif"

const LoadingGIF = () => {
    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 9999,
                padding: '16px',
                boxSizing: 'border-box',
            }}
        >
            <img
                src={GIF}
                alt="Loading"
                style={{
                    width: 'min(120px, 30vw)',
                    height: 'min(120px, 30vw)',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                }}
            />
        </div>
    );
};

export default LoadingGIF;